import { render } from "./DriversTable.vue?vue&type=template&id=3ebdd4c9&ts=true"
import script from "./DriversTable.vue?vue&type=script&lang=ts"
export * from "./DriversTable.vue?vue&type=script&lang=ts"

import "./DriversTable.vue?vue&type=style&index=0&id=3ebdd4c9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__